module.exports = __webpack_public_path__ + "img/celery.9537f81a.svg";